import {plural} from "../../../../../utils/js-utils";
import {ELLIPSIS} from "../../../../../utils/str.utils";
import {C} from "../../../../../configurations/active-configuration";

export const PART_NAME = 'transaction';
export const SUPPLIER_NAME = C.profile.s_col_name || 'supplier';

const P = PART_NAME;

type Msg = { msg: string, warning?: boolean, disabled?: boolean };

export function getEditAlertMessage(nT: number | null, nP: number | null): Msg {
    if (nT === null || nP === null) {
        return {
            msg: `Change the category of all ${plural(P)}. Counting total ${ELLIPSIS}`,
        };
    }
    const scope = nT - nP;

    if (scope === 0) {
        return {
            msg: `Cannot change the category as ${nP} ${plural(P, nP)} ${nP === 1 ? 'is' : 'are'} pending and cannot be changed.`,
            disabled: true,
        }
    }

    if (nP === 0) {
        return {
            msg: `Change the category of ${scope} ${plural(P, scope)}.`,
        };
    } else {
        // nP > 0
        return {
            msg: `Change the category of ${scope} ${plural(P, scope)}. ${nP} ${plural(P, nP)} ${nP === 1 ? 'is' : 'are'} pending and cannot be changed.`,
            warning: true,
        };
    }
}

export function getAcceptAlertMessage(nT: number | null, nP: number | null, nU: number | null): Msg {

    if (nT === null || nP === null || nU === null) {
        return {
            msg: `Accept the suggestion of all ${plural(P)}. Counting total ${ELLIPSIS}`,
        };
    }

    const scope = nT - nP - nU;

    if (scope === 0) {
        return {
            msg: `Cannot accept the suggestion as ${nU} ${plural(P, nU)} ${nU === 1 ? 'has' : 'have'} no suggestion.`,
            disabled: true,
        }
    }

    if (nP === 0 && nU === 0) {
        return {
            msg: `Accept the suggestion of ${scope} ${plural(P, scope)}.`,
        }
    }
    if (nP > 0 && nU === 0) {
        return {
            msg: `Accept the suggestion of ${scope} ${plural(P, scope)}. `
                + `${nP} ${plural(P, nP)} ${nP === 1 ? 'is' : 'are'} pending and cannot be accepted.`,
            warning: true,
        }
    }
    if (nP === 0 && nU > 0) {
        return {
            msg: `Accept the suggestion of ${scope} ${plural(P, scope)}. `
                + `${nU} ${plural(P, nU)} ${nU === 1 ? 'has' : 'have'} no suggestion and will not be accepted.`,
            warning: true,
        }
    }
    // nP > 0 && nU > 0
    return {
        msg: `Accept the suggestion of ${scope} ${plural(P, scope)}. `
            + `${nP} ${plural(P, nP)} ${nP === 1 ? 'is' : 'are'} pending and cannot be accepted. `
            + `${nU} ${plural(P, nU)} ${nU === 1 ? 'has' : 'have'} no suggestion and will not be accepted.`,
        warning: true,
    }
}